"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var TextArea = antd_1.Input.TextArea;
var DlgSendBroadcastRawPartnerMessage = /** @class */ (function (_super) {
    __extends(DlgSendBroadcastRawPartnerMessage, _super);
    function DlgSendBroadcastRawPartnerMessage(props) {
        return _super.call(this, props) || this;
    }
    DlgSendBroadcastRawPartnerMessage.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                message_title: data.messageTitle,
                message_text: data.messageText,
                pprogram_id: data.pprogramId,
                pprogram_title: data.pprogramTitle,
                pprograms_avail: data.pprogramsAvail,
                language_id: data.languageId,
                language_title: data.languageTitle,
                languages_avail: data.languagesAvail
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            message_title: "",
            message_text: "",
            pprogram_id: 0,
            pprogram_title: "",
            pprograms_avail: [],
            language_id: 0,
            language_title: "",
            languages_avail: []
        });
        this.doReSetRules();
    };
    DlgSendBroadcastRawPartnerMessage.prototype.doReSetRules = function () {
        this.setState({
            pprogram_rules: { isError: false },
            language_rules: { isError: false },
            message_title_rules: { isError: false },
            message_text_rules: { isError: false }
        });
    };
    DlgSendBroadcastRawPartnerMessage.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgSendBroadcastRawPartnerMessage.prototype.isDataValid = function () {
        this.doReSetRules();
        var is_data_valid = true;
        if ((!this.state.pprogram_title) || (this.state.pprogram_title.length === 0)) {
            this.setState({
                pprogram_rules: {
                    isError: true,
                    errorMessage: "Поле [Партнерская программа] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        if ((!this.state.language_title) || (this.state.language_title.length === 0)) {
            this.setState({
                language_rules: {
                    isError: true,
                    errorMessage: "Поле [язык] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        if ((!this.state.message_text) || (this.state.message_text.length === 0)) {
            this.setState({
                message_text_rules: {
                    isError: true,
                    errorMessage: "Поле [текст сообщения] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if ((!this.state.message_title) || (this.state.message_title.length === 0)) {
            this.setState({
                message_title_rules: {
                    isError: true,
                    errorMessage: "Поле [тема сообщения] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        return is_data_valid;
    };
    DlgSendBroadcastRawPartnerMessage.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.message_title, this.state.message_text, this.state.pprogram_id, this.state.language_id);
            }
        }
    };
    DlgSendBroadcastRawPartnerMessage.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgSendBroadcastRawPartnerMessage.prototype.onMessageTitleChange = function (e) {
        var _this = this;
        this.setState({
            message_title: e.target.value,
            message_title_rules: { isError: false }
        }, function () {
            _this.props.controller.SetMessageTitle(_this.state.message_title);
        });
    };
    DlgSendBroadcastRawPartnerMessage.prototype.onMessageBodyChange = function (e) {
        var _this = this;
        this.setState({
            message_text: e.target.value,
            message_text_rules: { isError: false }
        }, function () {
            _this.props.controller.SetMessageText(_this.state.message_text);
        });
    };
    DlgSendBroadcastRawPartnerMessage.prototype.getMessageTitleErrorRenderObject = function () {
        if (this.state.message_title_rules.isError) {
            return (React.createElement("div", { style: { width: "100%", textAlign: "left", margin: 5, marginLeft: 0, color: "red" } }, this.state.message_title_rules.errorMessage));
        }
        else {
            return null;
        }
    };
    DlgSendBroadcastRawPartnerMessage.prototype.getMessageTextErrorRenderObject = function () {
        if (this.state.message_text_rules.isError) {
            return (React.createElement("div", { style: { width: "100%", textAlign: "left", margin: 5, marginLeft: 0, color: "red" } }, this.state.message_text_rules.errorMessage));
        }
        else {
            return null;
        }
    };
    DlgSendBroadcastRawPartnerMessage.prototype.render = function () {
        var _this = this;
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 600 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа:", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.pprogram_id, value: this.state.pprogram_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            pprogram_id: newVal.key,
                            pprogram_title: newVal.value,
                            pprogram_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetPProgramId(_this.state.pprogram_id);
                            _this.props.controller.SetPProgramTitle(_this.state.pprogram_title);
                        });
                    }, items: this.state.pprograms_avail, required: true, rules: this.state.pprogram_rules }),
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.language_id, value: this.state.language_title }, onValueChanged: function (newVal) {
                        _this.setState({
                            language_id: newVal.key,
                            language_title: newVal.value,
                            language_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetLanguageId(_this.state.language_id);
                            _this.props.controller.SetLanguageTitle(_this.state.language_title);
                        });
                    }, items: this.state.languages_avail, required: true, rules: this.state.language_rules }),
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u0422\u0435\u043C\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"),
                React.createElement(antd_1.Input, { onChange: this.onMessageTitleChange.bind(this), value: this.state.message_title }),
                this.getMessageTitleErrorRenderObject(),
                React.createElement("div", { style: { width: "100%", textAlign: "left", fontWeight: "bold", margin: 5, marginLeft: 0 } }, "\u0422\u0435\u043A\u0441\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"),
                React.createElement(TextArea, { rows: 4, onChange: this.onMessageBodyChange.bind(this), value: this.state.message_text }),
                this.getMessageTextErrorRenderObject()));
    };
    return DlgSendBroadcastRawPartnerMessage;
}(React.Component));
exports.default = DlgSendBroadcastRawPartnerMessage;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgSendBroadcastRawPartnerMessage.tsx
// module id = 2452
// module chunks = 0